import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableKlaviyoIntegration = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableKlaviyoIntegration);
};
